import type {FC} from 'react'
import {BranchName, Label, Truncate} from '@primer/react'
import {GitBranchIcon, TagIcon} from '@primer/octicons-react'
import {unqualifyRef, mapRefType} from '@github-ui/ref-utils'
import styles from './RefPill.module.css'

const RefIcon: FC<{target: string}> = ({target}) => {
  const refType = mapRefType(target)
  if (refType === 'tag') {
    return <TagIcon className={styles.RefPillOcticon} />
  }
  if (refType === 'branch') {
    return <GitBranchIcon className={styles.RefPillOcticon} />
  }
  return null
}

type RefPillProps = {
  param: string
  displayAsLabel?: boolean
  showIcon?: boolean
  showQualifiedRef?: boolean
}

export const RefPill: FC<RefPillProps> = ({param, displayAsLabel = false, showIcon, showQualifiedRef}) => {
  if (displayAsLabel) {
    return <Label variant="secondary">{param}</Label>
  }
  if (showQualifiedRef) {
    return (
      <BranchName as="span">
        <Truncate title={param} className={styles.RefPillTruncate}>
          <span className={styles.RefPillText}>
            {showIcon ? <RefIcon target={param} /> : null}
            {param}
          </span>
        </Truncate>
      </BranchName>
    )
  }
  return (
    <BranchName as="span">
      <Truncate title={unqualifyRef(param) || ''} className={styles.RefPillTruncate}>
        <span className={styles.RefPillText}>
          {showIcon ? <RefIcon target={param} /> : null}
          {unqualifyRef(param)}
        </span>
      </Truncate>
    </BranchName>
  )
}
